import { playerStatic } from '../../../../../../configuration';

export const FONT_RATIOS = [
  { ratio: 0.6, label: 'Très petit' },
  { ratio: 0.8, label: 'Petit' },
  { ratio: 1, label: 'Standard' },
  { ratio: 1.2, label: 'Grand' },
  { ratio: 1.4, label: 'Très grand' }
];

export const MOCK_SUBTITLE_WRAPPER = (color, fontSize) => ({
  default: {
    backgroundImage: `url("${playerStatic.defaultBgImg}")`,
    objectFit: 'fit',
    color,
    flex: '0 0 auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    backgroundPosition: '-1px 0px',
    height: '60px',
    maxHeight: '60px',
    overflow: 'hidden',
    fontSize
  },
  'small+extraSmall': {
    maxHeight: '40px',
    height: '40px'
  },
  'large+extraLarge': {
    height: '80px',
    maxHeight: '80px'
  }
});

export const TRACK_SETTINGS_WRAPPER_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  marginLeft: '12px',
  marginRight: '10px'
};

export const SECTION_CONTENT_TRACK_SETTINGS_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  overflow: 'hidden',
  margin: '8px 0px'
};

export const STYLES_TRACK_SETTINGS_LETTER_RATIO = {
  display: 'flex',
  gap: '8px',
  marginLeft: '4px',
  alignItems: 'baseline',
  transform: 'translateY(-25%)'
};

export const STYLES_SUBTITLE_SETTINGS_SECTION_CONTENT = {
  display: 'flex',
  gap: '14px',
  flexDirection: 'column'
};

export const STYLES_SECTION_TRACK_SETTIONS_FOOTER = {
  display: 'flex',
  gap: '8px',
  flex: '0 0 auto',
  paddingLeft: '6px'
};

export const STYLES_WITH_SPACE = { display: 'flex', gap: '12px' };

export const FONT_SIZE_SUBTITLE = {
  default: { fontSize: 32 },
  extraSmall: { fontSize: 14 },
  'medium+small': { fontSize: 24 }
};
